// https://simple.wikipedia.org/wiki/Mebibyte
export const ONE_MEBIBYTE = 1_048_576;

// Attachments constants
export const MAX_FILE_SIZE = ONE_MEBIBYTE * 100;
